export default "__VITE_ASSET__Bfn6jsPs__"